const BrokenHeart = (): JSX.Element => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1715_38501)">
      <path
        d="M4.47547 22.4755L14.874 32.874C16.1043 34.1043 16.7195 34.7195 17.0574 34.5063C17.3953 34.293 17.1047 33.473 16.5237 31.8329L16.4733 31.6906C16.239 31.0293 16.1218 30.6987 16.1218 30.3548C16.1218 30.011 16.239 29.6804 16.4732 29.0191L18 24.7097L19.5267 20.4003C19.761 19.739 19.8782 19.4083 19.8782 19.0645C19.8782 18.7207 19.761 18.39 19.5268 17.7287L18.0351 13.5184L18.0252 13.4907C18.0077 13.4436 17.9866 13.3978 17.9623 13.3538L17.9477 13.3282L16.9385 11.5685C14.0785 6.58167 7.04206 6.16653 3.61553 10.7824C0.963945 14.3544 1.32986 19.3299 4.47547 22.4755Z"
        stroke="#3D3A62"
        strokeWidth="2"
      />
      <path
        d="M35.5245 22.4755L23.1205 34.8795C22.617 35.383 22.3653 35.6347 22.0964 35.5739C21.8275 35.513 21.7086 35.1775 21.4708 34.5063L20.4733 31.6906C20.239 31.0293 20.1218 30.6987 20.1218 30.3548C20.1218 30.011 20.239 29.6804 20.4732 29.0191L22 24.7097L23.5267 20.4003C23.761 19.739 23.8782 19.4083 23.8782 19.0645C23.8782 18.7207 23.761 18.39 23.5268 17.7287L22.1732 13.9083L22.1731 13.9081C22.1538 13.8534 22.1441 13.8261 22.1363 13.7994C22.0652 13.5567 22.0888 13.296 22.2022 13.0699C22.2147 13.045 22.2291 13.0198 22.258 12.9694L22.258 12.9694L23.0615 11.5685C25.9215 6.58167 32.9579 6.16653 36.3845 10.7824C39.0361 14.3544 38.6701 19.3299 35.5245 22.4755Z"
        stroke="#3D3A62"
        strokeWidth="2"
      />
    </g>
    <defs>
      <clipPath id="clip0_1715_38501">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default BrokenHeart;
